var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03Star(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 201 40",
    style: {
      enableBackground: "new 0 0 201 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDF00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,0l4.5,13.8h14.5l-11.8,8.5l4.5,13.8l-11.8-8.5L8.8,36.2l4.5-13.8L1.6,13.8h14.5L20.6,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,0l4.5,13.8h14.5l-11.8,8.5l4.5,13.8l-11.8-8.5l-11.8,8.5l4.5-13.8l-11.8-8.5h14.5L60.6,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.6,0l4.5,13.8h14.5l-11.8,8.5l4.5,13.8l-11.8-8.5l-11.8,8.5l4.5-13.8l-11.8-8.5h14.5L100.6,0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.6,0l4.5,13.8h14.5l-11.8,8.5l4.5,13.8l-11.8-8.5l-11.8,8.5l4.5-13.8l-11.8-8.5h14.5L140.6,0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.6,0l4.5,13.8h14.5l-11.8,8.5l4.5,13.8l-11.8-8.5l-11.8,8.5l4.5-13.8l-11.8-8.5h14.5L180.6,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Star);
export default __webpack_public_path__ + "static/media/03_star.aa0290d198a43666477b0785d3e54381.svg";
export { ForwardRef as ReactComponent };